import { useEffect, useState } from 'react';

const STORAGE_KEY = 'partsWidget.flag.adminNavV2';

function readEnvDefault(): boolean {
  const candidates = [
    import.meta.env?.VITE_ADMIN_NAV_V2 as string | boolean | undefined,
    import.meta.env?.VITE_FLAG_ADMIN_NAV_V2 as string | boolean | undefined,
    import.meta.env?.VITE_FEATURE_ADMIN_NAV_V2 as string | boolean | undefined,
  ];

  for (const value of candidates) {
    if (typeof value === 'string') {
      const normalized = value.toLowerCase();
      if (normalized === 'true') return true;
      if (normalized === 'false') return false;
    }
    if (typeof value === 'boolean') {
      return value;
    }
  }

  return true; // Enable admin nav by default
}

function readInitial(): boolean {
  const envDefault = readEnvDefault();
  if (typeof window === 'undefined') {
    return envDefault;
  }

  try {
    const stored = window.localStorage.getItem(STORAGE_KEY);
    if (stored === 'true') return true;
    if (stored === 'false') return false;
  } catch {
    // ignore storage access issues (e.g. Safari private mode)
  }

  return envDefault;
}

export function useAdminNavFlag(): boolean {
  const [enabled, setEnabled] = useState<boolean>(() => readInitial());

  useEffect(() => {
    if (typeof window === 'undefined') return;

    const handleStorage = (event: StorageEvent) => {
      if (event.key === STORAGE_KEY) {
        if (event.newValue === 'true') setEnabled(true);
        else if (event.newValue === 'false') setEnabled(false);
      }
    };

    window.addEventListener('storage', handleStorage);
    return () => window.removeEventListener('storage', handleStorage);
  }, []);

  return enabled;
}

export function setAdminNavFlag(enabled: boolean) {
  if (typeof window === 'undefined') return;
  try {
    window.localStorage.setItem(STORAGE_KEY, enabled ? 'true' : 'false');
  } catch {
    // ignore write failures; caller can decide how to report
  }
}
